import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { StatCard } from './metrics';
import { Boxes, TriangleAlert, Wrench, ShieldCheck } from 'lucide-react';

const OPTS = [
  { v: 7, l: 'Last 7 days' }, { v: 15, l: 'Last 15 days' }, { v: 30, l: 'Last month' },
  { v: 90, l: 'Last 3 months' }, { v: 0, l: 'All time' },
];

export function periodLabel(d) {
  const o = OPTS.find((x) => x.v === Number(d));
  return o ? o.l : 'Last month';
}

export function PeriodFilter({ value, onChange }) {
  return (
    <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
      <SelectTrigger data-testid="period-filter" className="w-40"><SelectValue /></SelectTrigger>
      <SelectContent>{OPTS.map((o) => <SelectItem key={o.v} value={String(o.v)}>{o.l}</SelectItem>)}</SelectContent>
    </Select>
  );
}

export function ActivityRow({ activity }) {
  if (!activity) return null;
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" data-testid="activity-row">
      <StatCard label="Installs" value={activity.installs} icon={Boxes} tone="text-blue-400" />
      <StatCard label="Damages" value={activity.damages} icon={TriangleAlert} tone="text-rose-400" />
      <StatCard label="Repairs" value={activity.repairs} icon={Wrench} tone="text-cyan-400" />
      <StatCard label="Inspections" value={activity.inspections} icon={ShieldCheck} tone="text-emerald-400" />
    </div>
  );
}
